import styled from 'styled-components'

interface FooterProps {
    background?: string
}

const Footer = styled.div<FooterProps>`
    bottom: 0;
    font-size: 12px;
    padding: 30px;
    position: absolute;
    text-align: center;
    width: 100%;

    ${({ background }) => background && `background: ${background};`}
`

export default Footer
